import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { handleAuthModal } from "../Redux/Auth";

const ProtectRoutes = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { accessToken } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!accessToken) {
      dispatch(handleAuthModal(true));
      navigate("/");
    }
  }, [accessToken, navigate, dispatch]);
  return <Outlet />;
};

export default ProtectRoutes;

export const ProtectedNavigate = ({ path, children }) => {
  const { accessToken } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (!accessToken) {
      dispatch(handleAuthModal(true));
      navigate("/");
    } else {
      navigate(path);
    }
  };

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        handleNavigation();
      }}
      style={{ cursor: "pointer" }}
    >
      {children}
    </div>
  );
};
export const ProtectedFunction = ({ onClick, children }) => {
  const { accessToken } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (!accessToken) {
      dispatch(handleAuthModal(true));
      navigate("/");
    } else {
      onClick();
    }
  };

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        handleNavigation();
      }}
      style={{ cursor: "pointer" }}
    >
      {children}
    </div>
  );
};
